var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-container-sitc",
          staticStyle: { "padding-bottom": "0px" },
        },
        [
          _c(
            "div",
            { staticClass: "filter-container-content" },
            [
              _c(
                "el-form",
                {
                  ref: "addUserChildrenRef",
                  staticClass: "search-form",
                  attrs: {
                    "label-position": "top",
                    model: _vm.searchFormDanger,
                    rules: _vm.searchFormDangerRules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-bottom reqired",
                      attrs: {
                        label: _vm.$t(
                          "userCenter.dangerousDeclaration.billNumber"
                        ),
                        prop: "blNo",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          size: "medium",
                          maxlength: "200",
                          clearable: "",
                        },
                        on: {
                          blur: _vm.loadDataByBLNo,
                          change: _vm.blNoChange,
                        },
                        model: {
                          value: _vm.searchFormDanger.blNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchFormDanger, "blNo", $$v)
                          },
                          expression: "searchFormDanger.blNo",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.searchFnDanger },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "userCenter.dangerousDeclaration.searchButton"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-plain-primary",
                          on: {
                            click: function ($event) {
                              return _vm.resetForm()
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("userCenter.newManifestEDI.resetButton")
                            ) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item-bottom",
                      attrs: {
                        label: _vm.$t(
                          "userCenter.dangerousDeclaration.shipNameVoyage"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("gl-ship-voyage", {
                                on: { handleOpenVessel: _vm.handleOpenVessel },
                                model: {
                                  value: _vm.searchFormDocument,
                                  callback: function ($$v) {
                                    _vm.searchFormDocument = $$v
                                  },
                                  expression: "searchFormDocument",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 18 } }, [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.searchFnDocument },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "userCenter.dangerousDeclaration.timeInquiryButton"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "search-warning-text" },
                                  [
                                    _vm._v(
                                      "\n                 " +
                                        _vm._s(
                                          _vm.$t(
                                            "userCenter.dangerousDeclaration.cutTime"
                                          )
                                        ) +
                                        "：" +
                                        _vm._s(_vm.doucmentCutTimeData) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isDelayTime
                    ? _c(
                        "span",
                        {
                          staticClass: "search-warning-text",
                          staticStyle: { "margin-left": "0" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "userCenter.dangerousDeclaration.delayTime"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "filter-container-content " }, [
            _c("div", { staticClass: "table-info-content" }, [
              _c("div", { staticClass: "info-content-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("userCenter.dangerousDeclaration.searchTitle")
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "info-content-digit" },
                [
                  _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("userCenter.dangerousDeclaration.billNumber")
                        ) +
                        ": " +
                        _vm._s(_vm.searchFormDanger.blNo) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "60px" } }, [
                    _vm._v(
                      "\n             " +
                        _vm._s(
                          _vm.$t("userCenter.dangerousDeclaration.goodsTickets")
                        ) +
                        ": " +
                        _vm._s(_vm.listQuery.total) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-primary",
                      staticStyle: { "margin-left": "170px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.openDialog },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "userCenter.dangerousDeclaration.paperUploadButton"
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-content-warning" }, [
                _c("div", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "userCenter.dangerousDeclaration.shipWarningInfo"
                        )
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "userCenter.dangerousDeclaration.copyWarningInfo"
                        )
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new" },
              [
                _c(
                  "hot-table",
                  {
                    ref: "hotTableCostMain",
                    attrs: {
                      "has-tip": "",
                      "data-source": _vm.tableDataMain,
                      settings: _vm.hotSettings,
                      "current-page": _vm.listQuery.currentPage,
                      "page-size": _vm.listQuery.pageSize,
                      "selection-column-title": _vm.$t("table.No"),
                    },
                    on: { rowClick: _vm.tableRowClick },
                  },
                  [
                    _c("hot-column", {
                      attrs: {
                        data: "declarationAckId",
                        title: _vm.$t(
                          "userCenter.dangerousDeclaration.cargoDeclarationReceiptNumber"
                        ),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "apStatus",
                        title: _vm.$t(
                          "userCenter.dangerousDeclaration.hazardousDeclarationPaper"
                        ),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "acceptedStatus",
                        title: _vm.$t(
                          "userCenter.dangerousDeclaration.acceptanceMark"
                        ),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "lockStatus",
                        title: _vm.$t(
                          "userCenter.dangerousDeclaration.lockStatus"
                        ),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "remark",
                        title: _vm.$t(
                          "userCenter.dangerousDeclaration.remarks"
                        ),
                        "class-name": "htCenter",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "pagePanel",
                  staticStyle: { "text-align": "left" },
                  attrs: {
                    total: _vm.listQuery.total,
                    page: _vm.listQuery.currentPage,
                    limit: _vm.listQuery.pageSize,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "currentPage", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "pageSize", $event)
                    },
                    pagination: _vm.searchFn,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChangeSailSchedule,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.dangerousDeclaration.paperUploadButton"),
            visible: _vm.dangerDialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dangerDialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "dangerFormRef",
                      staticClass: "form-bill",
                      attrs: { model: _vm.dangerForm, "label-width": "100px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "userCenter.dangerousDeclaration.paperUploadButton"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "upload-demo",
                              attrs: {
                                action: "",
                                multiple: false,
                                "http-request": _vm.uploadFile,
                                "file-list": _vm.fileList,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-upload2",
                                    size: "small",
                                    plain: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "userCenter.dangerousDeclaration.uploadButton"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-button-bottom",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium" },
                      on: {
                        click: function ($event) {
                          _vm.dangerDialogVisible = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "userCenter.dangerousDeclaration.closeButton"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }